import { render, staticRenderFns } from "./BasicSchool.vue?vue&type=template&id=4fc47846&scoped=true&"
import script from "./BasicSchool.vue?vue&type=script&lang=js&"
export * from "./BasicSchool.vue?vue&type=script&lang=js&"
import style0 from "./BasicSchool.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BasicSchool.vue?vue&type=style&index=1&id=4fc47846&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc47846",
  null
  
)

export default component.exports